<template>
  <form-section @scroll.native="true" v-if="items">
    <div class="title">
      {{ $t('Profiles_Locations_Title_Locations') }}
      <i
        v-if="items.data.length > 0"
        class="el-icon-refresh"
        @click="refreshList"
      ></i>
    </div>

    <div class="scrollable-area" v-if="items.data.length > 0">
      <profile-location-item
        v-for="(item, index) in reversedItems"
        :key="index"
        :item="item"
        @select-location="selectLocation"
        :class="{ 'active-class': index === activeItem }"
        :index="index"
      />
    </div>

    <div class="scrollable-area" v-else>
      <p class="no-results-found-text">
        <i class="el-icon-warning-outline"></i>
        {{ $t('Profiles_Locations_Text_NoLocationsFound') }}
      </p>
    </div>
  </form-section>
</template>

<script>
import ProfileLocationItem from '@/modules/profiles/components/ProfileLocationsListItem'
import FormSection from '@/common/components/form/FormSection'

export default {
  name: 'ProfileLocationsList',

  components: {
    FormSection,
    ProfileLocationItem
  },

  props: {
    items: {
      required: true
    }
  },

  data() {
    return {
      activeItem: null
    }
  },

  methods: {
    refreshList() {
      this.$emit('refresh-list')
    },

    selectLocation(item, index) {
      this.activeItem = index
      this.$emit('select-location', item)
    }
  },

  computed: {
    reversedItems() {
      return this.items.data.reverse()
    }
  }
}
</script>

<style scoped>
.title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
  color: #333333;
  text-align: center;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
}

.title > i {
  transition: all 0.3s ease-in-out;
}

.title > i:hover {
  cursor: pointer;
  transform: scale(1.3);
  color: #7d8495;
}

.scrollable-area {
  height: 412px;
  overflow: auto;
}

>>> .el-card__body {
  padding: 20px 0px 0px 0px;
}

/* Scrollbar */

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  width: 5px;
  background: #7e8596;
  border-radius: 5px;
}

.active-class {
  background-color: #f2f5f9;
}

.no-results-found-text {
  text-align: center;
  font-size: 15px;
  color: #acb0b5;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/ProfileLocationsList.vue